export { default } from './withTableService';
